<template>
  <el-scrollbar height="calc(100vh - 46px - 60px - 60px)">
    <el-menu v-if="showDayMenu">
      <el-menu-item @click="getTaskByCategory()"> All </el-menu-item>
      <el-menu-item
        :index="key"
        v-for="(item, key) in dayList"
        :key="key"
        @click="getTaskByCategory(item)"
      >
        {{ item.title }}
      </el-menu-item>
    </el-menu>
    <template v-if="showOtherMenu">
      <el-divider v-if="showDayMenu" />
      <CustomButtonSetting />
    </template>

  </el-scrollbar>
</template>


<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import CustomButtonSetting from '@/components/CustomButton/Setting'

const DAY_MILSEC = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      chosenCategory: {},
      dayList: [],
    };
  },
  components: {
    CustomButtonSetting
  },
  computed: {
    ...mapGetters("User", ["user"]),
    isFirefighter() {
      return _.some(this.user.roles, (role) => role.roleName === "Firefighter");
    },
    isManager() {
      return _.some(this.user.roles, (role) => role.roleName === "Manager");
    },
    rolesLoaded() {
      return Array.isArray(this.user.roles);
    },
    showDayMenu() {
      return this.rolesLoaded && (!this.isFirefighter || this.isManager);
    },
    showOtherMenu() {
      return this.isFirefighter;
    },
  },
  methods: {
    getTaskByCategory(elem) {
      this.toggleMenu = false;
      const url = new URL(window.location);

      if (elem) {
        // this.chosenCategory = elem.text;

        url.searchParams.set("filter[mustDone]", elem.value);
        url.searchParams.delete("filter[location]");
        url.searchParams.delete("filter[category]");
        url.searchParams.delete("filter[minFilling]");
        url.searchParams.delete("filter[maxFilling]");
        url.searchParams.delete("filter[zoneIds]");
        window.history.pushState({}, "", url);

        this.$router.replace(`${this.$route.path}?${url.search}`);
      } else {
        url.searchParams.delete("filter[mustDone]");
        url.searchParams.delete("filter[location]");
        url.searchParams.delete("filter[category]");
        url.searchParams.delete("filter[minFilling]");
        url.searchParams.delete("filter[maxFilling]");
        url.searchParams.delete("filter[zoneIds]");

        window.history.pushState({}, "", url);

        this.$router.replace(`${this.$route.path}?${url.search}`);
      }
    },
    getCategoryNameWithCount(elem) {
      let count = 0;

      _.each(this.copyTaskList, (item) => {
        if (item.categoryId == Number(elem.id)) {
          count++;
        }
      });

      return `${elem.name} (${count})`;
    },
    getDay(date) {
      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      return {
        text: `${days[date.getDay()]} (${moment(date).format("DD-MM")})`,
        value: moment(date).format("YYYY-MM-DD"),
      };
    },
  },
  mounted() {
    let today = new Date().getTime();
    for (let i = 0; i < 7; i++) {
      let date = new Date(today + DAY_MILSEC * i);

      this.dayList.push({
        value: this.getDay(date).value,
        title: this.getDay(date).text,
      });
    }
    this.chosenCategory = this.dayList[0];
  },
};
</script>

<style lang="scss" scoped>
.left-menu {
  overflow-y: scroll;
  // padding-bottom: 15px;

  .el-menu-item {
    height: 35px;
  }
}
</style>